// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleArrowButton_root__vatmb","_reverced":"SimpleArrowButton__reverced__AR_s6"};